export class TableData {
  meta!: string[];
  data!: string[];
}
